<template>
  <card :title="$t('your_info')">
      <!-- Name -->
      <div class="form-group row" v-if="user">
        <div class="col-md-4">
          <label class="control-label">{{ $t('common.first_name') }}</label>
          <input v-model="user.first_name"
                 :class="{ 'field-error' : this.$v.user.first_name.$error }"
                 class="form-control" type="text">
        </div>
        <div class="col-md-4">
          <label class="control-label">{{ $t('common.last_name') }}</label>
          <input v-model="user.last_name"
                 :class="{ 'field-error' : this.$v.user.last_name.$error }"
                 class="form-control" type="text" name="last_name">
        </div>
      </div>

      <!-- Email -->
      <div class="form-group row" v-if="user">
        <div class="col-md-8">
          <label class="col-md-3">{{ $t('common.e_mail') }}</label>
          <input v-model="user.email"
                 :class="{ 'field-error' : this.$v.user.email.$error }"
                 disabled
                 class="form-control" type="email" name="email">
        </div>
      </div>

      <div class="form-group row" v-if="user">
        <div class="col-md-4">
          <label class="control-label">{{ $t('language') }}</label>
          <select v-model="selectedLanguage" class="form-control">
            <option v-for="language in languages" :key="language.value" :value="language.value">
              {{ language.label }}
            </option>
          </select>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group row">
        <div class="col-md-9 ml-md-auto">
          <v-button :loading="busy" type="outline-primary" @click="update">
            {{ $t('common.update') }}
          </v-button>
        </div>
      </div>
  </card>
</template>

<script>
import { mapGetters } from 'vuex'
import {errorMessage, successMessage} from "@/helpers/common";
import required from "vuelidate/src/validators/required";

export default {
  name: 'Profile',
  scrollToTop: false,

  metaInfo () {
    return { title: this.$t('common.settings') }
  },

  data() {
      return {
          user: {},
        selectedLanguage: 'en',
        languages: [
          { value: 'en', label: 'English' },
          { value: 'hu', label: 'Magyar' },
          { value: 'ro', label: 'Romana' },
        ],
        busy: false,
      }
  },

  computed: mapGetters({
    userData: 'auth/user'
  }),

  methods: {
    async update () {
        let vm = this;
        this.$v.user.$touch();
        if(this.$v.user.$invalid) {
          return;
        }

        this.busy = true;
        try {
          const profileResponse = await this.$store.dispatch('auth/updateMyAccount', this.user);
          const selectedLanguage = (this.selectedLanguage || 'en').toLowerCase();

          await this.$store.dispatch('auth/updateMyLanguage', { lang: selectedLanguage });

          this.$i18n.locale = selectedLanguage;
          this.user = {
            ...profileResponse.data,
            lang: selectedLanguage,
          };

          successMessage(vm, profileResponse.message);
        } catch (e) {
          errorMessage(vm, e.message || e?.errors?.error || this.$t('error_alert_text'));
        } finally {
          this.busy = false;
        }
    }
  },
    mounted() {
        this.user = { ...(this.userData || {}) };
        this.selectedLanguage = (this.user?.lang || this.$i18n.locale || 'en').toLowerCase();
    },
  validations() {
      return {
          user: {
              first_name: {
                  required,
              },
              last_name: {
                  required,
              },
              email: {
                  required,
              },
          },
      }
  },
}
</script>
